export const Chain = 'chain';
export const FirmGroup = 'firmGroup';
export const Firm = 'firm';
export const Agent = 'agent';
